module.exports = __webpack_public_path__ + "static/media/top-bottom.d68dfa99.svg";